import { gql, useQuery } from '@apollo/client';
import { useApolloClient } from '@apollo/client/react/hooks/useApolloClient';

import { TClient } from 'types';

export const useClientData = (
  clientUUID: string | null
): {
  data: Pick<TClient, 'phone' | 'id'> | null;
  loading: boolean;
  error?: any;
} => {
  const apolloClient = useApolloClient();

  const cachedData = clientUUID
    ? apolloClient.readFragment<Pick<TClient, 'phone' | 'id'>>({
        id: apolloClient.cache.identify({
          __typename: 'User',
          uuid: clientUUID,
        }),
        fragment: gql`
          fragment ClientId on User {
            id
            phone
          }
        `,
      })
    : null;

  const { data, loading, error } = useQuery<{
    user: Pick<TClient, 'phone' | 'id'>;
  }>(
    gql`
      query GetClientData($uuid: String!) {
        user(uuid: $uuid) {
          id
          phone
          uuid
        }
      }
    `,
    {
      variables: { uuid: clientUUID ?? '' },
      skip: !clientUUID || !!cachedData,
      fetchPolicy: 'network-only',
    }
  );

  return {
    data: cachedData ?? data?.user ?? null,
    loading: !cachedData && loading,
    error,
  };
};
